__turbopack_context__.v({
  "current_section_list_item": "summary-module-scss-module__cbYDAq__current_section_list_item",
  "summary_bottom_section": "summary-module-scss-module__cbYDAq__summary_bottom_section",
  "summary_main_section": "summary-module-scss-module__cbYDAq__summary_main_section",
});
